export default IconPointOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-point-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9.15 9.194a4 4 0 0 0 5.697 5.617m1.153 -2.811a4 4 0 0 0 -4 -4" />
  <path d="M3 3l18 18" />
</svg>`;